import HealthcareOverride from "../services/HealthcareOverride";

export default {

    components: { },

    props: [ 'homeUrl', 'pageType', 'productsUrl'],

    data: () => ({
        modalShowState: true,
        showStaticAnim: false,
        loadingState: false,
    }),

    mounted() {
        console.log(this.pageType);
    },

    methods: {
        close: function () {
            this.modalShowState = false;
            document.body.classList.remove('modal-open')
        },
        cancel: function() {
            this.loadingState = true;
            HealthcareOverride.Submit('consumer', this.pageType)
                .then((res) => this.finishSaved(res))
        },
        confirm: function() {
            this.loadingState = true;
            HealthcareOverride.Submit('healthcare_professional', this.pageType)
                .then((res) => this.finishSaved(res))
        },
        finishSaved: function (response){
            this.loadingState = 'saved';

            if (response === 'healthcare_professional') {
                setTimeout(() => {
                    this.close();
                },500);
                return;
            }

            location.href = this.productsUrl;
        },
        esc: function() {
            this.showStaticAnim = true;
            setTimeout(() => {
                this.showStaticAnim = false;
            },200)
        }

    },

}
